var _this = this;
import * as tslib_1 from "tslib";
import { bookapiRoomCateringUpsellingActionTypes } from './ActionTypes';
import { RoomCateringUpsellingResponse } from '../../../globalTypes';
export var getRoomCateringUpsellingResponse = function (roomCateringUpsellingRequest) {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var roomCateringUpsellingResponse, content, res, response, error_1, receiveBookapiRoomCateringUpsellingState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    roomCateringUpsellingResponse = new RoomCateringUpsellingResponse();
                    content = 'offerKey=' + roomCateringUpsellingRequest.offerKey + '&productType=' + roomCateringUpsellingRequest.productType;
                    if (typeof roomCateringUpsellingRequest.selectedOfferKey !== 'undefined') {
                        content += '&selectedOfferKey=' + roomCateringUpsellingRequest.selectedOfferKey;
                    }
                    roomCateringUpsellingResponse.setIsOk(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(roomCateringUpsellingRequest.url, {
                            method: 'POST',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: content // body data type must match "Content-Type" header
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    response = _a.sent();
                    if (typeof response.roomUpsellingRates !== 'undefined' && response.roomUpsellingRates.length > 1) {
                        response.roomUpsellingRates.forEach(function (value) {
                            roomCateringUpsellingResponse.addRoomUpsellingRate(value);
                        });
                    }
                    if (typeof response.cateringUpsellingRates !== 'undefined' && response.cateringUpsellingRates.length > 1) {
                        response.cateringUpsellingRates.forEach(function (value) {
                            roomCateringUpsellingResponse.addCateringUpsellingRate(value);
                        });
                    }
                    roomCateringUpsellingResponse.setIsOk(true);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 5:
                    receiveBookapiRoomCateringUpsellingState = {
                        'type': bookapiRoomCateringUpsellingActionTypes.RECEIVE_BOOKAPI_ROOM_CATERING_RATE_STATE,
                        'roomCateringUpsellingResponse': roomCateringUpsellingResponse
                    };
                    return [2 /*return*/, dispatch(receiveBookapiRoomCateringUpsellingState)];
            }
        });
    }); };
};
